import React, { useEffect, useState, useCallback } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import Topbar from "./topBar/top-bar";
import Sidebar from "./sideBar/side-bar";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HomePage from "../home/home";
import SupportTaskList from "../tasks/supportTaskList/support-task-list";
import ManagerTaskList from "../tasks/mangerTaskList/manager-task-list";
import TaskHistory from "../tasks/tasksHistory/tasks-history";
import CreateTaskDialog from "../tasks/mangerTaskList/manager-task-create";
import MenuIcon from "@mui/icons-material/Menu";
import DailyLogs from "../logs/daily-logs";
import DailyLogIncident from "../logs/dailyLog/daily-log-incident";
import NonPhysicalIntervention from "../logs/nonPhysicalIntervention/non-physical-intervention";
import ManagerDefaultTaskAssign from "../tasks/mangerTaskList/managerDefaultTask/manager-default-task-assign";
import ManagerTaskForms from "../tasks/managerSubTaskCreation/manger-task-forms";
import CauseForConcern from "../logs/causeForConcern/cause-for-concern";
import IncidentManagementView from "../logs/manger/managerForms/incident-management-view";
import SafeGuardingView from "../logs/manger/managerForms/safe-guarding-view";
import CauseForConcernView from "../logs/manger/managerForms/cause-for-concern-view";
import ManagerIncompleteTaskAssign from "../tasks/mangerTaskList/managerIncompleteTask/manager-incomplete-task-assign";
import DailyLogsHistory from "../logs/daily-logs-history";

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const searchParams = new URLSearchParams(location.search);
  const taskId = searchParams.get("id");

  // Sidebar collapse state
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(window.innerWidth < 1024);

  // Function to render forms dynamically based on URL path
  const renderForm = useCallback(() => {
    switch (location.pathname) {
      case "/logout":
        return <HomePage />;
      case "/manager-all-tasks":
        return <ManagerTaskList />;
      case "/task-history":
        return <TaskHistory />;
      case "/logs-incident":
        return <DailyLogIncident taskId={taskId} />;
      case "/non-physical":
        return <NonPhysicalIntervention taskId={taskId} />;
      case "/daily-logs":
        return <DailyLogs />;
        case "/daily-logs-history":
        return <DailyLogsHistory />;
      case "/manager-task-assign":
        return <ManagerDefaultTaskAssign />;
      case "/manager-task-create":
        return <CreateTaskDialog />;
      case "/manager-task-complete":
        return <SupportTaskList />;
      case "/manager-task-incomplete":
        return <ManagerIncompleteTaskAssign />;
      case "/manager-task-form":
        return <ManagerTaskForms />;
      case "/cause-concern":
        return <CauseForConcern taskId={taskId} />;
      case "/incident-management-view":
        return <IncidentManagementView />;
      case "/safe-guarding-view":
        return <SafeGuardingView />;
      case "/cause-concern-view":
        return <CauseForConcernView />;
      default:
        return user.roleid === 4 ? <SupportTaskList /> : user.roleid === 2 || user.roleid === 3 ? <></> : <></>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, user.roleid]);

  useEffect(() => {
    // Handle browser resizing
    const handleResize = () => {
      setIsSidebarCollapsed(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      if (window.location.pathname === "/login") {
        navigate("/dashboard", { replace: true }); // Redirect to dashboard instead of login
      }
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <Box>
      <Box>
        <Topbar />
      </Box>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 10,
          zIndex: 1000,
          display: "flex",
          backgroundColor: "white",
        }}
      >
        {isSidebarCollapsed ? (
          <Grid container mt={3} ml={5}>
            <Grid item>
              <IconButton
                onClick={() => {
                  setIsSidebarCollapsed(false);
                }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <img src='/images/logo.png' alt='Active Care Logo' className='sidebar-logo' />
            </Grid>
          </Grid>
        ) : (
          <Sidebar setIsSidebarCollapsed={setIsSidebarCollapsed} />
        )}
      </Box>
      <Box mt={10} ml={window.innerWidth < 1024 ? 0 : 30}>
        {renderForm()}
      </Box>
    </Box>
  );
};

export default Dashboard;
